/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { ListingPageTrackingProps } from './useListingPageTracking.types';
import { trackPage } from 'shared/helpers/trackPage';
import {
    hasMortgageCalculator,
    removeNullAnalyticValues
} from 'listing-details/helpers';
import { createMortgageTrackingLabel } from 'listing-details/components/MortgageCalculator/MortgageCalculator.tracking';
import { useApolloClient } from '@apollo/client';

export const useListingPageTracking = ({
    data,
    listingSection,
    query
}: ListingPageTrackingProps): void => {
    const page = `/${data.section}/details/`;

    const ecommerce = {
        detail: {
            products: [removeNullAnalyticValues(data.analyticsEcommerce)]
        }
    };

    let mortgageProvideLabel;

    if (hasMortgageCalculator(data.analyticsTaxonomy.priceQualifier)) {
        mortgageProvideLabel = createMortgageTrackingLabel({
            data,
            listingSection
        });
    }

    const taxonomy = removeNullAnalyticValues({
        activity: 'listing_details',
        mortgage_calculator_displayed: '',
        page,
        url: data.listingUris.detail,
        search_identifier: (query['search_identifier'] as string) || null,
        ...data.analyticsTaxonomy,
        ...(mortgageProvideLabel && { mortgage_provider: mortgageProvideLabel })
    });

    const client = useApolloClient();

    useEffect(() => {
        trackPage(page, taxonomy, ecommerce, client);
    }, [data.analyticsTaxonomy.listingId]);
};
